/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Assistant_History_YesterdayInputs */



/**
* | output |
* | --- |
* | "Yesterday" |
*
* @param {Assistant_History_YesterdayInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const assistant_history_yesterday = /** @type {((inputs?: Assistant_History_YesterdayInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Assistant_History_YesterdayInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Hier")
	if (locale === "de") return /** @type {LocalizedString} */ ("Gestern")
	if (locale === "it") return /** @type {LocalizedString} */ ("Ieri")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Вчера")
	if (locale === "es") return /** @type {LocalizedString} */ ("Ayer")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("昨天")
	if (locale === "ja") return /** @type {LocalizedString} */ ("昨日")
	if (locale === "hi") return /** @type {LocalizedString} */ ("कल")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Ontem")
	return /** @type {LocalizedString} */ ("Yesterday")
});